import {
  BANNER_DATA,
  CARDS_EFFECT,
  DEMO_LIST,
  SCENARIO,
  BRAND,
  ADVANTAGES_EFFECT,
} from '../../utils/const/products/beautification';

import styles from '../../styles/common.module.scss';

import DetailBanner from '../../components/commonComponents/detailBanner';
import Introduction from '../../components/productPageComponents/introduction';
import FeatureExperience from '../../components/productPageComponents/featureExperience';
import Scenarios from '../../components/productPageComponents/scenario';
import FeatureCard from '../../components/commonComponents/featureCard';
import Brand from '../../components/commonComponents/brandCard';
import router from 'next/router';

/**
 *
 * @description 人美化页面
 */
const BeautifyMan = () => {
  return (
    <div className={styles.wrapper}>
      <DetailBanner
        bannerData={BANNER_DATA}
        onTry={() => router.push('/form/consult/try-buti')}
      />
      <Introduction cards={CARDS_EFFECT} initialOpen={true} />
      <FeatureCard advantages={ADVANTAGES_EFFECT} bgColor="#f8f9fa" />
      <FeatureExperience demoList={DEMO_LIST} showPanel={true} />
      <Scenarios scenarios={SCENARIO} bgColor="#f8f9fa" hoverEffect="" />
      <Brand title={BRAND.title} config={BRAND.items} />
    </div>
  );
};

export default BeautifyMan;
